'use client';

import { useRouter } from 'next/navigation';
import { ReactNode, useTransition } from 'react';
import { useDisconnect } from 'wagmi';
import { logout } from '../logout-method';

export const LogoutAndDisconnectWalletButton = ({
  fallback,
  children,
}: {
  fallback?: () => void;
  children: ReactNode;
}) => {
  const [isPending, startTransition] = useTransition();
  const { disconnectAsync } = useDisconnect();
  const { refresh } = useRouter();

  return (
    <button
      type="button"
      className="btn btn-primary"
      onClick={async () => {
        startTransition(async () => {
          await logout();
          await disconnectAsync();
          refresh();
          fallback?.();
        });
      }}
    >
      {isPending ? <span className="loading loading-spinner loading-sm" /> : children}
    </button>
  );
};

export const LogoutButton = ({
  fallback,
  children,
  className,
}: {
  fallback?: () => void;
  children: ReactNode;
  className?: string;
}) => {
  const { refresh } = useRouter();
  const [isPending, startTransition] = useTransition();

  return (
    <button
      type="button"
      className={className}
      onClick={async () => {
        startTransition(async () => {
          await logout();
          refresh();
          fallback?.();
        });
      }}
    >
      {isPending ? <span className="loading loading-spinner loading-sm" /> : children}
    </button>
  );
};
